import * as types from './constants';

// Delete Group
export const deleteGroupRequest = data => (
  { type: types.DELETE_GROUP_REQUEST, payload: data }
);

export const deleteGroupDone = data => (
  { type: types.DELETE_GROUP_DONE, payload: data }
);

export const deleteGroupFailed = errors => (
  { type: types.DELETE_GROUP_FAILED, payload: errors }
);